import angular from 'angular';
import { digits } from './digits.filter';

export const DigitsFilterModule = angular
  .module('app.filters.digits', [])
  .filter('digits', () => digits);
